import { getWebApp } from './telegram';

export const AppMode = {
  /** Мини-приложение внутри Telegram: вход по подписанному initData. */
  TELEGRAM: 'telegram',
  /** Веб-версия на основном домене: гостевой вход и лендинг. */
  WEB: 'web',
} as const;
export type AppMode = (typeof AppMode)[keyof typeof AppMode];

/**
 * Режим определяется в рантайме, а не на сборке: один и тот же артефакт
 * обслуживает оба домена, поэтому пересборка при смене домена не нужна и
 * версии не расходятся.
 *
 * Признак Telegram — наличие initData, а не имя хоста: клиент может открыть
 * мини-приложение по любому адресу, а хост webapp.* нужен лишь как запасной
 * признак для отладки.
 */
export function detectAppMode(): AppMode {
  if (getWebApp()?.initData) {
    return AppMode.TELEGRAM;
  }
  return window.location.hostname.startsWith('webapp.') ? AppMode.TELEGRAM : AppMode.WEB;
}

export const appMode = detectAppMode();
export const isTelegramMode = appMode === AppMode.TELEGRAM;
